module.exports = __webpack_public_path__ + "static/media/trendex-usa-min.8188fa25.png";